// systemInfo.ts

// Function to Get Operating System
import {logDebug, logTrace} from "./logger";
import {deviceType} from "../constants";
import {deflate} from "node:zlib";

function getOS(): string {
  const platform = navigator.platform.toLowerCase();
  const userAgent = navigator.userAgent.toLowerCase();

  if (platform.includes('win')) return 'Windows';
  if (platform.includes('mac')) return 'MacOS';
  if (platform.includes('linux')) return 'Linux';
  if (userAgent.includes('android')) return 'Android';
  if (userAgent.includes('iphone') || userAgent.includes('ipad')) return 'iOS';

  return 'Unknown OS';
}

function getDeviceType() {
  const ua = navigator.userAgent;

  const isMobileDevice = /Mobile|Android|iP(ad|hone|od)|IEMobile|WPDesktop/.test(ua);
  const isTabletDevice = /Tablet|iPad/.test(ua);

  logTrace("getDeviceType - isMobileDevice:", isMobileDevice, " ua:", ua);
  if (isMobileDevice) return deviceType.mobile;
  if (isTabletDevice) return deviceType.tablet;
  return deviceType.desktop;
}



function getUTCTime(): string {
  const offset = new Date().getTimezoneOffset(); // in minutes
  const hours = Math.floor(Math.abs(offset) / 60);
  const minutes = Math.abs(offset) % 60;
  const sign = offset <= 0 ? '+' : '-';

  return `UTC${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}

function getUTCDate(): string {
  return new Date().toISOString();
}



// Function to Get Browser Type
function getBrowserType(): string {
  const userAgent = navigator.userAgent;

  if (userAgent.includes('Chrome') && !userAgent.includes('Edge') && !userAgent.includes('OPR')) return 'Chrome';
  if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) return 'Safari';
  if (userAgent.includes('Firefox')) return 'Firefox';
  if (userAgent.includes('Edge')) return 'Edge';
  if (userAgent.includes('OPR') || userAgent.includes('Opera')) return 'Opera';
  if (userAgent.includes('Trident') || userAgent.includes('MSIE')) return 'Internet Explorer';

  return 'Unknown Browser';
}

// Example usage
logDebug("Operating System:", getOS());
logDebug("Device Type:", getDeviceType());
logDebug("UTC Date Offset:", getUTCDate());
logDebug("UTC Time Offset:", getUTCTime());
logDebug("Browser Type:", getBrowserType());

export { getOS, getDeviceType, getUTCDate, getUTCTime, getBrowserType };
